import General from './modules/general';
import Styles from './modules/styles';
import ScrollToTop from './modules/scroll-to-top';
import StickyAddToCart from './modules/sticky-add-to-cart';
import { initAllCarousels } from './modules/carousel-swiper';
import initFluentFormPlaceholder from './modules/fluent-form-placeholder';
import initAllFloatingPlaceholders from './modules/floating-placeholder';
import initQuantityInput from './modules/quantity-input';
import initProductsPage from './modules/products-page';
import ShoppingLayer from './modules/shopping-layer';
import initCartPage from './modules/cart-page';
import initAuthValidation from './modules/auth-validation';
import initKasselogin from './modules/kasselogin';
import initClubDiscount from './modules/club-discount';
import initPasswordToggle from './modules/password-toggle';
import initCheckoutPayment from './modules/checkout-payment';

document.addEventListener('DOMContentLoaded', () => {
    window.Styles = new Styles();
    window.General = new General();
    window.ScrollToTop = new ScrollToTop();
    window.StickyAddToCart = new StickyAddToCart();
    initAllCarousels();
    initFluentFormPlaceholder();
    initAllFloatingPlaceholders();
    initQuantityInput();
    initProductsPage();
    window.ShoppingLayer = new ShoppingLayer();
    initCartPage();
    initAuthValidation();
    initKasselogin();
    initClubDiscount();
    initPasswordToggle();
    initCheckoutPayment()
}, false);
